import React from "react";

export const MessageSvg = () => {
  return (
    <>
      <svg
        width="28"
        height="28"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="48" height="48" rx="10" fill="#E1E7FA" />
        <path
          d="M36 17.3332V30.6665C36 34.6665 34 37.3332 29.3333 37.3332H18.6667C14 37.3332 12 34.6665 12 30.6665V17.3332C12 13.3332 14 10.6665 18.6667 10.6665H29.3333C34 10.6665 36 13.3332 36 17.3332Z"
          stroke="#3A0CA3"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27.3333 14V16.6667C27.3333 18.1333 28.5333 19.3333 30 19.3333H32.6666"
          stroke="#3A0CA3"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.6667 25.3335H24"
          stroke="#3A0CA3"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.6667 30.6665H29.3334"
          stroke="#292D32"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
